import examsPresets from "./exams-presets"
import markersPresets from "./markers-presets"
import offices from "./offices"
import secretaries from "./secretaries"
import therapiesPresets from "./therapies-presets"

export default {
	markersPresets,
	examsPresets,
	therapiesPresets,
	offices,
	secretaries
}
